import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Registro } from './pages/Registro';
import { Gracias } from './pages/Gracias';
import { Control } from './pages/Control';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/registro" element={<Registro data-id="element-3" />} data-id="element-2" />
        <Route path="/gracias" element={<Gracias data-id="element-5" />} data-id="element-4" />
        <Route path="/control" element={<Control data-id="element-7" />} data-id="element-6" />
        <Route path="*" element={<Navigate to="/registro" replace data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}